import React from 'react';
import { ModalComponent } from '../../../components/Modal/ModalComponent';

type ConnectOverlayProps = {
  variant: 'connect';
  isOpen: boolean;
  title: string;
  body: string;
  closeLabel: string;
  onClose: () => void;
};

type RetryOverlayProps = {
  variant: 'retry';
  isOpen: boolean;
  title: string;
  body: string;
  closeLabel: string;
  returnToChatLabel: string;
  retryLabel: string;
  onClose: () => void;
  onReturnToChat: () => void;
  onRetry: () => Promise<void> | void;
};

type ChatOverlayErrorDialogProps = ConnectOverlayProps | RetryOverlayProps;

export const ChatOverlayErrorDialog: React.FC<ChatOverlayErrorDialogProps> = (props) => {
  if (!props.isOpen) {
    return null;
  }

  if (props.variant === 'connect') {
    const modalObject = {
      showModal: props.isOpen,
      dialogClass: 'chatbot-exit-modal chatbot-inline-error-dialog chatbot-connect-error-dialog',
      portalContainerSelector: '.chatbot-window',
      backdropClassName: 'chatbot-inline-backdrop',
      modalClassName: 'chatbot-inline-dialog-shell',
      head: {
        modalTitle: props.title,
      },
      body: {
        bodyClass: 'chatbot-connect-error-modal-body',
      },
      clickHandler: props.onClose,
      showHeaderCloseBtn: false,
      css: {
        modalHeader: 'chatbot-visually-hidden',
        modalTitle: 'chatbot-visually-hidden',
      },
    };

    return (
      <ModalComponent modalObject={modalObject}>
        <div className="chatbot-connect-error-card">
          <div className="chatbot-connect-error-icon" aria-hidden="true">
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.9836 2.26946C18.836 -0.857177 23.4985 -0.753149 25.1639 2.58163L41.4813 35.2527L41.6135 35.5467C42.8858 38.5812 40.6637 42.0039 37.3046 42.0043H4.67205C1.20417 42.0042 -1.05156 38.3553 0.497565 35.2527L16.8127 2.58163L16.9836 2.26946ZM4.67205 37.3377H37.3046L20.9894 4.66658L4.67205 37.3377ZM20.9872 30.3377C22.2758 30.3377 23.3205 31.3824 23.3205 32.671C23.3203 33.9595 22.2757 35.0044 20.9872 35.0044C19.6991 35.0038 18.6541 33.9592 18.6538 32.671C18.6538 31.3827 19.699 30.3382 20.9872 30.3377ZM20.9872 14.0044C22.2758 14.0044 23.3205 15.0491 23.3205 16.3378V25.6711C23.3203 26.9595 22.2757 28.0044 20.9872 28.0044C19.6991 28.0039 18.6541 26.9592 18.6538 25.6711V16.3378C18.6538 15.0494 19.699 14.005 20.9872 14.0044Z" fill="#407196"/>
            </svg>
          </div>
          <h2 className="chatbot-connect-error-title">{props.title}</h2>
          <div className="chatbot-connect-error-body">{props.body}</div>
          <button
            type="button"
            className="btn btn-secondary w-100"
            onClick={props.onClose}
          >
            {props.closeLabel}
          </button>
        </div>
      </ModalComponent>
    );
  }

  const modalObject = {
    showModal: props.isOpen,
    dialogClass: 'chatbot-exit-modal chatbot-inline-error-dialog',
    portalContainerSelector: '.chatbot-window',
    backdropClassName: 'chatbot-inline-backdrop',
    modalClassName: 'chatbot-inline-dialog-shell',
    head: {
      modalTitle: props.title,
    },
    body: {
      bodyClass: 'chatbot-inline-error-body',
    },
    footer: {
      footerChild: (
        <>
          <button
            type="button"
            className="chatbot-btn chatbot-btn-secondary btn-cancel"
            onClick={props.onReturnToChat}
          >
            {props.returnToChatLabel}
          </button>
          <button
            type="button"
            className="chatbot-btn chatbot-btn-primary"
            onClick={() => {
              void props.onRetry();
            }}
          >
            {props.retryLabel}
          </button>
        </>
      ),
    },
    clickHandler: props.onClose,
    showHeaderCloseBtn: true,
    css: {
      modalFooter: 'chatbot-inline-error-footer',
    },
  };

  return (
    <ModalComponent modalObject={modalObject}>
      <div className="chatbot-inline-error-copy">{props.body}</div>
    </ModalComponent>
  );
};
